
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/blog/two-way-sync-diagram-is-the-automation",
      function () {
        return require("private-next-pages/site/blog/two-way-sync-diagram-is-the-automation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/blog/two-way-sync-diagram-is-the-automation"])
      });
    }
  